export default __webpack_public_path__ + "static/media/shape-U.2b97a810.svg";